module.exports = __webpack_public_path__ + "img/dke.9be3ba38.jpg";